var scope_0 = require('D:/Codes/Github-Reactale/reacto/gatsby-src/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1e0cda732cdd33f311498a9120a85e01.js').default;
var scope_1 = require('D:/Codes/Github-Reactale/reacto/gatsby-src/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/46dac4312756812f35d43aaee93b48cf.js').default;
var scope_2 = require('D:/Codes/Github-Reactale/reacto/gatsby-src/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_3 = require('D:/Codes/Github-Reactale/reacto/gatsby-src/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/eae6981a1a4a176a297cdb5b05be2820.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    